import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 0 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 70px;\n  box-shadow: ", ";\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import 'react-circular-progressbar/dist/styles.css';
import React from 'react';
import noop from 'lodash/noop';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { theme } from '../theme';
import styled from '../utils/styling/styled-components';
import { PROGRESS_LOADING_SPINNER } from '../utils/testing/TestIDs';
import { BaseModal } from '../Modal';
import { ScreenReaderOnly } from '../ScreenReaderOnly'; // Props directly related to CircularProgressbarWithChildren Import

var LoaderImage = styled.div(_templateObject(), function (props) {
  return props.iconContainerWidth ? props.iconContainerWidth : '70px';
}, function (props) {
  return props.iconContainerHeight ? props.iconContainerHeight : '70px';
}, function (props) {
  return props.theme.shadows.smMedium;
}, function (props) {
  return props.theme.colors.white;
});
var LoaderContainer = styled.div(_templateObject2());
var Container = styled.div(_templateObject3(), function (props) {
  return props.containerWidth ? props.containerWidth : '90px';
}, function (props) {
  return props.containerHeight ? props.containerHeight : '90px';
});
var MODAL_LABEL = 'progress_loader';

var CircularProgressBar = function CircularProgressBar(_ref) {
  var progressAmount = _ref.progressAmount,
      icon = _ref.icon,
      styleProps = _ref.styleProps,
      background = _ref.background,
      backgroundPadding = _ref.backgroundPadding,
      containerWidth = _ref.containerWidth,
      containerHeight = _ref.containerHeight,
      iconContainerWidth = _ref.iconContainerWidth,
      iconContainerHeight = _ref.iconContainerHeight,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(LoaderContainer, {
    "aria-busy": "true",
    className: className
  }, /*#__PURE__*/React.createElement(ScreenReaderOnly, {
    id: MODAL_LABEL
  }, "Loading..."), /*#__PURE__*/React.createElement(Container, {
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    "data-testid": PROGRESS_LOADING_SPINNER
  }, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: progressAmount,
    strokeWidth: 2,
    background: background,
    backgroundPadding: backgroundPadding,
    styles: buildStyles(styleProps)
  }, /*#__PURE__*/React.createElement(LoaderImage, {
    iconContainerWidth: iconContainerWidth,
    iconContainerHeight: iconContainerHeight
  }, icon))));
};

var ProgressLoader = function ProgressLoader(_ref2) {
  var progressAmount = _ref2.progressAmount,
      animationTiming = _ref2.animationTiming,
      icon = _ref2.icon,
      _ref2$shouldShowOverl = _ref2.shouldShowOverlay,
      shouldShowOverlay = _ref2$shouldShowOverl === void 0 ? false : _ref2$shouldShowOverl,
      containerWidth = _ref2.containerWidth,
      containerHeight = _ref2.containerHeight,
      iconContainerWidth = _ref2.iconContainerWidth,
      iconContainerHeight = _ref2.iconContainerHeight,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(BaseModal, {
    accessibilityProperties: {
      labelledBy: MODAL_LABEL
    },
    hasOverlayBackground: shouldShowOverlay,
    isOpen: true,
    isTrapModal: true,
    onRequestClose: noop,
    className: className
  }, /*#__PURE__*/React.createElement(CircularProgressBar, {
    progressAmount: progressAmount,
    icon: icon,
    background: true,
    backgroundPadding: 6,
    styleProps: {
      pathTransitionDuration: animationTiming,
      pathColor: theme.colors.green,
      trailColor: theme.colors.ivory,
      backgroundColor: theme.colors.white
    },
    containerHeight: containerHeight,
    containerWidth: containerWidth,
    iconContainerHeight: iconContainerHeight,
    iconContainerWidth: iconContainerWidth
  }));
};

export { ProgressLoader };